import React, { useEffect, useState } from "react";
import { api, formatError } from "../../lib/api";
import { fileUrl } from "../../lib/seo";
import { Button } from "../../components/ui/button";
import { PhotoViewer } from "../../components/ImpactReportsSection";
import { toast } from "sonner";

const pill = { pending: "bg-amber-100 text-amber-800", approved: "bg-green-100 text-green-800", rejected: "bg-red-50 text-red-800" };

function AdminReportRow({ r, onReview }) {
  const [idx, setIdx] = useState(null);
  return (
    <div data-testid={`admin-report-${r.id}`} className="bg-[#FFFDF9] sacred-border rounded-2xl p-5 flex flex-col md:flex-row gap-5">
      <div className="flex gap-2 flex-wrap md:w-72 shrink-0">
        {r.photo_urls.map((u, i) => <button key={u} onClick={() => setIdx(i)}><img src={fileUrl(u)} alt="" className="w-20 h-20 object-cover rounded-lg" /></button>)}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2"><span className={`px-2 py-0.5 rounded-full text-xs capitalize ${pill[r.status]}`}>{r.status}</span><span className="text-xs text-[#63534E]">{r.ngo_name} · {r.project_title}</span></div>
        <div className="font-serif text-xl text-[#4A0E17] mt-2">{r.title}</div>
        <p className="text-sm text-[#63534E] mt-1 whitespace-pre-line">{r.body}</p>
        {r.review_note && <p className="text-xs text-red-700 mt-1">Note: {r.review_note}</p>}
      </div>
      {r.status === "pending" && (
        <div className="flex md:flex-col gap-2 shrink-0">
          <Button data-testid={`report-approve-${r.id}`} onClick={() => onReview(r, "approve")} className="h-8 text-xs rounded-full bg-[#2F7D32] hover:bg-[#1B5E20]">Approve</Button>
          <Button data-testid={`report-reject-${r.id}`} onClick={() => onReview(r, "reject")} className="h-8 text-xs rounded-full bg-red-700 hover:bg-red-800">Reject</Button>
        </div>
      )}
      <PhotoViewer photos={r.photo_urls} idx={idx} setIdx={setIdx} caption={r.title} />
    </div>
  );
}

export default function ImpactReportsAdminTab() {
  const [items, setItems] = useState([]);
  const [status, setStatus] = useState("pending");
  const load = () => api.get("/admin/impact-reports", { params: status ? { status } : {} }).then((r) => setItems(r.data.items));
  useEffect(() => { load(); }, [status]); // eslint-disable-line react-hooks/exhaustive-deps
  const review = async (r, action) => {
    const note = action === "reject" ? window.prompt("Reason (shown to the NGO)") || "" : "";
    try { await api.put(`/admin/impact-reports/${r.id}`, { action, note }); toast.success(`Update ${action}d`); load(); }
    catch (e) { toast.error(formatError(e)); }
  };
  return (
    <div data-testid="impact-reports-admin-tab">
      <div className="flex gap-2 mb-4">
        {[["pending", "Waiting"], ["approved", "Approved"], ["rejected", "Rejected"], ["", "All"]].map(([k, l]) => (
          <button key={l} data-testid={`impact-filter-${k || "all"}`} onClick={() => setStatus(k)} className={`px-3 h-8 rounded-full text-xs border ${status === k ? "bg-[#4A0E17] text-[#F3E5AB] border-[#4A0E17]" : "bg-white text-[#4A0E17] border-[#D4AF37]/40"}`}>{l}</button>
        ))}
      </div>
      <div className="space-y-4">
        {items.length === 0 && <div className="text-sm text-[#63534E] py-10 text-center">Nothing here.</div>}
        {items.map((r) => <AdminReportRow key={r.id} r={r} onReview={review} />)}
      </div>
    </div>
  );
}
